import React from 'react';
import PropTypes from 'prop-types';

import './BottomSheet.scss';

const buildClassName = (base, extra) => (extra ? `${base} ${extra}` : base);

export default function BottomSheet({
    id = undefined,
    isOpen = false,
    isResizing = false,
    height = undefined,
    className = '',
    panelClassName = '',
    contentClassName = '',
    handleAriaLabel = 'Resize panel',
    handleAriaControls = undefined,
    onHandlePointerDown = undefined,
    onHandleKeyDown = undefined,
    children = null,
}) {
    const rootClassName = buildClassName(
        `bottom-sheet${isOpen ? ' is-open' : ' is-closed'}${isResizing ? ' is-resizing' : ''}`,
        className,
    );
    const panelStyle = height != null ? { '--bottom-sheet-height': `${height}px` } : undefined;

    return (
        <div className={rootClassName}>
            <div
                id={id}
                className={buildClassName('bottom-sheet__panel', panelClassName)}
                style={panelStyle}
                aria-hidden={!isOpen}
                inert={isOpen ? undefined : ''}
            >
                <div
                    className="bottom-sheet__handle"
                    role="separator"
                    aria-orientation="horizontal"
                    aria-label={handleAriaLabel}
                    aria-controls={handleAriaControls || id}
                    tabIndex={isOpen ? 0 : -1}
                    onPointerDown={onHandlePointerDown}
                    onKeyDown={onHandleKeyDown}
                >
                    <span className="bottom-sheet__grabber" aria-hidden="true" />
                </div>
                <div className={buildClassName('bottom-sheet__content', contentClassName)}>
                    {children}
                </div>
            </div>
        </div>
    );
}

BottomSheet.propTypes = {
    id: PropTypes.string,
    isOpen: PropTypes.bool,
    isResizing: PropTypes.bool,
    height: PropTypes.number,
    className: PropTypes.string,
    panelClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    handleAriaLabel: PropTypes.string,
    handleAriaControls: PropTypes.string,
    onHandlePointerDown: PropTypes.func,
    onHandleKeyDown: PropTypes.func,
    children: PropTypes.node,
};
